export default ({ data }) => {
  return {
    text: data.text,
    subText: data.subtext,
  };
};
